import { render, staticRenderFns } from "./search-screen.vue?vue&type=template&id=976e2640&scoped=true"
import script from "./search-screen.vue?vue&type=script&lang=js"
export * from "./search-screen.vue?vue&type=script&lang=js"
import style0 from "./search-screen.vue?vue&type=style&index=0&id=976e2640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976e2640",
  null
  
)

export default component.exports